export enum CaseStatusEnum {
  Ny = 935000001,
  Underbehandling = 935000002,
  Godkjent = 935000006,
  Tilutbetaling = 935000003,
  Gjenpnet = 935000005,
  Avslag = 935000004,
  Avsluttet = 935000007,
}
